import '../App.less';
import { Layout, Row, Col,ConfigProvider,Card } from 'antd';
import React, { Component } from "react";
import cabezal from './Cabezal.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Foot from "./components/Footer"
import { withTranslation  } from 'react-i18next';
import UserMenu from './components/UserMenu';

class Home extends Component {
  render() {
  const t = this.props.t

    return (
      <div className="page-container">
      <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
            <Row>
            <UserMenu showOnlyLanguage/>
            </Row>
          <Row justify="center" align="middle" >
            <Col xs={{span:24}} sm={{span:18}}>
              <Card title={t('Coloquio Internacional de Estudios sobre Culturas Originarias de América')} bordered={false}>
                <p>
                {t("El Coloquio Internacional de Estudios sobre Culturas Originarias de América, convocado por primera vez en 2014, se realiza con frecuencia bienal en torno al 12 de octubre, día de la Resistencia Indígena. El evento busca propiciar un acercamiento a la historia, la memoria, los saberes, la espiritualidad y los actuales desafíos de los pueblos indígenas de Abya Yala e Isla Tortuga, así como dar a conocer sus realidades y su producción cultural desde perspectivas diversas.")}  
                </p>
                <p>{t("Convocado a partir de un tema central, el Coloquio funciona como un espacio de encuentro y diálogo entre investigadores, creadores y activistas tanto indígenas como no indígenas. Hasta el momento, hemos contado con la participación de representantes de los pueblos amuzga, anishinaabe, asháninka, atikamekw, aymara, bribri, brörán, caribe, colla, comcáac, diné, guna, hurón, innu, kichwa, lil’watul, mapuche, maya achí, maya chortí, maya k’iche’, maya kaqchikel, maya tujaal, mazateco, miskito, nahua, pemón, quechua, taíno, tu`un savi, wendat, zapoteco, entre otros.")}  </p>
                <p>{t("Como resultado del evento se ha publicado el libro Saberes y expresiones artísticas de los Pueblos Indígenas en el horizonte del Buen Vivir. Además, la declaración resultante del primer encuentro fue elevada por Cuba a la secretaría de Naciones Unidas y circulada en español e inglés como aporte (A/69/357) a la Conferencia Mundial sobre Pueblos Indígenas, realizada en la ONU, en septiembre de aquel año (2014). El 12 de octubre de 2018 los participantes del III Coloquio elaboraron la Declaración de La Habana sobre Idiomas Indígenas.")}   </p>
                <Row justify="left" align="left" gutter={24}>
                  <Col xs={{span:19}} sm={{span:6}} >
                    <Button  style={{backgroundColor:'gray', color:'white', width:'150px'}}><NavLink to="/culturasOriginarias/registro/panel">{t("Registro Panel")}  </NavLink></Button>
                  </Col>
                  <Col xs={{span:19}} sm={{span:6}} >
                    <Button  style={{backgroundColor:'gray', color:'white', width:'150px'}}><NavLink to="/culturasOriginarias/registro/ponencia">{t("Registro Ponencia")}  </NavLink></Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Layout>
      </ConfigProvider>
    </div>
   <Foot/>
</div>
    );
  }
}
export default withTranslation()(Home);


